/// <reference types="./filters.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function filters() {
  return $svg.square(
    20,
    "<path d=\"M8.33333 15H11.6667V13.3333H8.33333V15ZM2.5 5V6.66667H17.5V5H2.5ZM5 10.8333H15V9.16667H5V10.8333Z\" fill=\"currentColor\"/>",
  );
}
